/**
 * Leaderboard cache module
 * Provides caching for leaderboard data with time-based expiration
 */

// Cache expiration time: 5 minutes (in milliseconds)
const CACHE_EXPIRATION_TIME = 5 * 60 * 1000;

// Cache storage
let cache = {
  data: null,
  timestamp: null
};

/**
 * Check if the cache is valid (exists and hasn't expired)
 * @returns {boolean} True if cache is valid, false otherwise
 */
export const isCacheValid = () => {
  if (!cache.data || !cache.timestamp) {
    return false;
  }
  
  const now = Date.now();
  const age = now - cache.timestamp;
  return age < CACHE_EXPIRATION_TIME;
};

/**
 * Get cached leaderboard data if valid
 * @returns {Array|null} Cached data if valid, null otherwise
 */
export const getLeaderboardCache = () => {
  if (isCacheValid()) {
    return cache.data;
  }
  return null;
};

/**
 * Store leaderboard data in cache with current timestamp
 * @param {Array} data - Leaderboard data to cache
 */
export const setLeaderboardCache = (data) => {
  cache.data = data;
  cache.timestamp = Date.now();
};

/**
 * Clear the leaderboard cache
 */
export const clearLeaderboardCache = () => {
  cache.data = null;
  cache.timestamp = null;
};

